export default __webpack_public_path__ + "static/media/Website_Background_opaque.8a70ab01.png";